import {
  WSButton,
  WSFlexBox,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import { DepositProduct } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useHistory } from "react-router";
import { usePaymentsStatusQuery } from "../../../query/payments/queries";
import { WS_LINKS } from "../../../types/wsLinks";
import { openInNewTab } from "../../../utils/openInNewTab";

interface Props {}

export const WingspanAccounts: React.FC<Props> = () => {
  const history = useHistory();
  const qPaymentsStatusQuery = usePaymentsStatusQuery();

  const handleDepositAccountLimits = () => {
    const url = (WS_LINKS.depositLimit as any)[
      qPaymentsStatusQuery.data?.bankingAccountTier as DepositProduct
    ];
    openInNewTab(url ?? "https://wingspan.app");
  };

  return (
    <WSPanel mt="M">
      <WSFlexBox direction="column">
        <WSText.Heading3 mb="XS">Wingspan Accounts</WSText.Heading3>
        <WSText.Paragraph color="grey600" mb="S">
          Wingspan manages a bank account on your behalf for accepting bank
          transfer payments and tax withholdings.
        </WSText.Paragraph>
        <WSButton.Link
          mb="S"
          onClick={() => history.push("/member/bank-statements")}
        >
          View Statements
        </WSButton.Link>
        <WSButton.Link
          mb="S"
          onClick={() => openInNewTab(WS_LINKS.electronicDisclosure)}
        >
          Electronic Consent Disclosure
        </WSButton.Link>
        <WSButton.Link
          mb="S"
          onClick={() => openInNewTab(WS_LINKS.depositAccountTermsConditions)}
        >
          Deposit Account Terms
        </WSButton.Link>
        <WSButton.Link mb="S" onClick={handleDepositAccountLimits}>
          Deposit Account Limits
        </WSButton.Link>
      </WSFlexBox>
    </WSPanel>
  );
};
